import { BenefitsSlider } from "../../components/benefits/BenefitsSlider";
import { BenefitsMosaic } from "~/components/benefits/BenefitsMosaic";
import { ImageWidget as Image } from "~/types/widgets";
import { HTMLWidget as HTML } from "~/types/widgets";
import clsx from "~/sdk/clx";
import { type FnContext as FnContext, type SectionProps as SectionProps } from "~/types/deco";
/**
 * @title Benefício
 * @titleBy label
 */
export interface Item {
    /** @title Imagem */
    image?: Image;
    /** @title URL */
    href?: string;
    /** @title Abrir em nova aba */
    target?: boolean;
    /** @title Descrição */
    description: HTML;
    /** Título */
    label: string;
}
/** @title Benefícios */
export interface BenefitsSectionProps {
    items: Item[];
    /**
     * @title Formato do componente
     */
    layout?: 'slider-desktop' | 'slider-desktop-mobile' | 'mobile-mosaic';
}
const BenefitsSection = ({ items, layout, isMobile }: SectionProps<typeof loader>) => {
    if (!items?.length)
        return null;
    const renderSliderOnMobile = layout === 'slider-desktop-mobile';
    const renderMosaic = layout === 'mobile-mosaic';
    if (renderMosaic) {
        return (<div className='p-3 lg:hidden'>
                <BenefitsMosaic items={items}/>
            </div>);
    }

    //<div className={clsx(!renderSliderOnMobile && 'hidden lg:block', renderSliderOnMobile && 'block')}>
            //<BenefitsSlider items={items} renderSliderOnMobile isMobile={isMobile}/>
        //</div>

    return (
        <>
        {!renderSliderOnMobile && isMobile ? (
            <></>
        ) : (
            <BenefitsSlider items={items} renderSliderOnMobile isMobile={isMobile}/>
        )}
        </>
        );
};
export default BenefitsSection;
export const loader = (props: BenefitsSectionProps, _: Request, ctx: FnContext) => {
    return { ...props, isMobile: ctx.device !== 'desktop' };
};
export function LoadingFallback(props: Partial<BenefitsSectionProps>) {
    return <BenefitsSection {...(props as SectionProps<typeof loader>)} />
}
export const sync = true;
